import {Component, Input, OnInit, ViewChild} from '@angular/core';

@Component({
	selector: 'app-pdf-view-blocks-medical-test',
	templateUrl: './pdf-view-blocks-medical-test.component.html',
	styleUrls: ['./pdf-view-blocks-medical-test.component.scss']
})
export class PdfViewBlocksMedicalTestComponent implements OnInit {

	@Input()
	tableData;

	constructor() {
	}

	async ngOnInit() {

	}

}
